/* Daza Organic · «Por qué elegirnos»: entrada escalonada de las razones.
   Toda la animación es CSS (daza-razones.css); este script solo escalona
   los retrasos y pone la clase que la dispara, una vez, cuando la lista
   entra en pantalla. Sin JS, sin IntersectionObserver o con movimiento
   reducido no se toca nada y todo se ve desde el principio. */
(function () {
  'use strict';

  function iniciar() {
    var reduce = window.matchMedia('(prefers-reduced-motion:reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    document.querySelectorAll('.s-razones:not([data-anima])').forEach(function (seccion) {
      var lista = seccion.querySelector('.s-razones__lista');
      if (!lista) return;
      seccion.dataset.anima = '1';

      lista.querySelectorAll('.s-razones__item').forEach(function (item, i) {
        item.style.setProperty('--rz-i', i);
      });
      seccion.classList.add('s-razones--anima');

      var observer = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (entrada) {
          if (!entrada.isIntersecting) return;
          observer.disconnect();
          seccion.classList.add('es-visible');
        });
      }, { threshold: 0.15 });
      observer.observe(lista);
    });
  }

  iniciar();
  document.addEventListener('shopify:section:load', iniciar);
})();
